import React from 'react';
import { LayersIcon, ScanEyeIcon, GitCompareIcon, BookOpenIcon, GiftIcon, ClipboardCheckIcon } from 'lucide-react';
const POINTS = [{
  icon: LayersIcon,
  title: 'Des planches visuelles prêtes à consulter',
  body: 'Structures annotées en radio, scanner et IRM : ouvrez l’atlas et retrouvez le repère, au lieu de chercher dans plusieurs supports.'
}, {
  icon: ScanEyeIcon,
  title: 'Une méthode de lecture pour chaque examen',
  body: 'Quoi regarder en premier, dans quel ordre, ce que l’examen montre et ce qu’il ne montre pas.'
}, {
  icon: GitCompareIcon,
  title: 'Des comparaisons côte à côte',
  body: 'Normal ou pathologique, variante ou anomalie, artefact ou vraie image : chaque confusion fréquente a son repère visuel.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Des protocoles et des check-lists de terrain',
  body: 'Positionnement, critères de qualité, sécurité IRM, radioprotection et traçabilité, prêts à l’emploi.'
}, {
  icon: BookOpenIcon,
  title: '6 modules complémentaires',
  body: 'Anatomie, techniques d’imagerie, sémiologie, protocoles et radioprotection, cas illustrés, workflows et outils.'
}, {
  icon: GiftIcon,
  title: '5 bonus pratiques',
  body: 'Anatomie en coupes, normal vs anormal, décodeur densités et séquences, check-lists de lecture et cahier d’exercices.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-111" data-mp="2xouy29n3xfrc">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-112" data-mp="2xnjwmgh4wk3e">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-113" data-mp="2sruq1t6p62xl">
          CE N’EST PAS UN SIMPLE EBOOK DE PLUS SUR LA RADIOLOGIE
        </h2>
        <p className="mt-1 text-center font-display text-sm font-bold uppercase leading-tight text-tech-light sm:text-xl" data-id="element-114" data-mp="2jqetao8t1zbu">
          C’EST UN SYSTÈME VISUEL COMPLET POUR LIRE LES IMAGES ET TRAVAILLER AVEC MÉTHODE.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-115" data-mp="18aq2tmwcei6a">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3" data-id="element-116" data-mp="1er83jjb8ffpy">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech-light" aria-hidden="true" data-id="element-117" data-mp="ztfp6uhf8xdc" />
                <div data-id="element-118" data-mp="14rh91hmo90pv">
                  <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-119" data-mp="14v544l7rlv6p">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-120" data-mp="qzkn5vbljn1x">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-white sm:text-lg" data-id="element-121" data-mp="h4sm2hit2i2e">
          Moins de lectures au hasard. <span className="text-tech-light" data-id="element-122" data-mp="m07yd51605wp">Plus de méthode, examen après examen.</span>
        </p>
      </div>
    </section>;
}